import { render, staticRenderFns } from "./ContractorDocuments.vue?vue&type=template&id=c27627d4&"
import script from "./ContractorDocuments.vue?vue&type=script&lang=ts&"
export * from "./ContractorDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports